
import React from 'react';
export default function Blog007() {
  return (
    <>
    <section>
    <article>
      <h2>7. 08-16-2022</h2>
      <h3>Week 6</h3>
      <p> 
        Hello everyone, <br />
        I am writing this before I record the vlog video listed in the links below. <br />
        I have been spending a bit of time increasing my WPM (Words per minute)/typing speed. Keeping up with verbal communication as a typist is a valuable skill as a developer; as communicating to computers is the literal job description. Writing a blog is a great exercise for this exact task, for this reason I may over-explain some things, or seem a bit long winded. 
        <br />
        In short, the unnecessary text has a purpose!
        <br />
        <br />
        As I have stated earlier I am writing this blog before I record the week 6 Vlog. With the Vlog in mind, let's lay out what I have done this week; and where I plan to go next.
        <br />
        </p>
        <ul>
        <li>Blog updates with github</li>
        <li>Math Quiz Game</li>
        <li>Tap to Flap</li>
        </ul>
        <p>
        <br />
        I am making an effort to update this blog regularly. I decided to create my own blog with custom code. This is great practice for coding, typing, and increases my webspace visibility.
        <br />
         This is also a great landing page and index for all of my projects. This helps me keep organized and gives a clear date for career related milestones. I plan to continue this blog for years to come. Though I am sure it will evolve along the way. <br />
        <br />
        I was so excited to get the Math Quiz working. I learned a lot from this tutorial as I mentioned in an earlier blog. To sum it up quickly, I learned functions, manipulating the DOM, button functionality: Start and Restart, Wrong answer and Right answer, 
        <br />
        <br />
        The tap to flap, which is clearly not a Flappy Birds Clone, was a fun challenge. I did not focus on the cosmetics for this project. I specifically wanted to focus on the gears and bolts of the game. I learned how to simulate gravity, add a character to a game, control the character with a button, and basic collisions! 
        <br />
        <br />
        Yes, that was a lot to learn from two projects. I feel that to get the most out of these tutorials I will either do them both again, or follow along with a tutorial of the same, or similar, game. I am also thinking of spacing out the timing of recording the Vlog. I enjoy showing off the weeks work, but the further I am getting into Javascript, the longer the project takes. The quality of project will go up, but the quantity will go down. I don’t want to show off projects before they are done, and I dont wan’t to rush along projects. The point of these projects are for me to learn and understand, giving me tools to move on and create my own projects. Showing these projects off are just a bonus. <br />
        I am also aware these kinds of projects are not portfolio material. <br />
        The conclusion is that I am focusing on learning and creating this blog. The Vlog, while still important, is secondary and will therefore be uploaded less often.
        <br />
        <br />
        That being said I would like to do more live programming. Some hard evidence of my ability to struggle through problems. I would also like to work on some pair programming, preferably with some programmers around the same ability level as myself. 
        <br />
        <br />
        Alright then, I am signing off, till next time <br /><br /> -Eric
        

      </p> 
    </article>

    <h4>Links</h4>
    <br />
    <ul>
      <li>
        <a
          href="https://www.youtube.com/watch?v=hHKFmBqIjoU&list=PLce5_YZyrUw7dNEL7F1T4kxAp0mMuattO"
          title="Vlog"
        >
          <strong><p>THE VLOG - Video Blog Series</p></strong></a
        >
      </li>
      <li>
        <a
          href="https://ericpolley.github.io/Math-Quiz/"
          title="Math Quiz Game"
        >
          <strong><p>Math Quiz Game</p></strong></a
        >
      </li>
      <li>
        <a
          href="https://ericpolley.github.io/taptoflap/"
          title="Tap to Flap"
        >
          <strong><p>Tap to Flap Game!</p></strong></a
        >
      </li>
      <li>
        <a
          href="http://erpolley.com"
          title="Check out my website"
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>

  </>
  )
}
